/**
 * Vendor detail page -- /twin/vendor/:id (P2.7.e).
 * Thin wrapper around EntityDetailLayout. v0.2.0 ships null chips
 * (backlog #435). Vendor entities only ever populate the blast chip
 * (the other 3 chains don't accept entity_kind=vendor); the chip
 * aggregator backlog handles that nuance.
 */
import { useParams } from "react-router-dom";

import { EntityDetailLayout } from "twin/entity/EntityDetailLayout";
import { VendorArrangementsPanel } from "twin/entity/VendorArrangementsPanel";

const NULL_CHIPS = {
  resilience: null,
  blast_ibs_count: null,
  process_count: null,
  obligation_count: null,
} as const;

export function VendorDetail() {
  const { id } = useParams<{ id: string }>();
  // Round 20 V6 -- contracts, no-objection and exit plan, on the page.
  return (
    <EntityDetailLayout
      kind="vendor"
      entityId={id}
      chips={NULL_CHIPS}
      story={<VendorArrangementsPanel vendorId={id} />}
    />
  );
}
